@if (!isWatchingFromApp && !this.isSdui) {
  <nb-card-header [ngClass]="iconCustomLayoutClass()" >
    <a (click)="backUrlClick()" style="cursor: pointer;"
      class="header-btn">
      @if (displayStyle === 'circular') {
        <span class="material-symbols-outlined">chevron_left</span>
      } @else {
        <img src="/assets/images/bt-back-new.svg" class="icons-svg-list">
      }
    </a>
  </nb-card-header>
}

@if (!isWatchingFromApp && this.isSdui) {
  <nb-card-header [ngClass]="iconCustomLayoutClass()" >
    <a (click)="back()" style="cursor: pointer;"
      class="header-btn">
      @if (displayStyle === 'circular') {
        <span class="material-symbols-outlined">chevron_left</span>
      } @else {
        <img src="/assets/images/bt-back-new.svg" class="icons-svg-list">
      }
    </a>
  </nb-card-header>
}
